export const agendaLocations = [
    {
        "id": "RmllbGRWYWx1ZV8xOTEwNTI2NA==",
        "name": "summit-stage",
        "value": "summit-stage"
    },
    {
        "id": "RmllbGRWYWx1ZV8xOTEwNTI2NQ==",
        "name": "future-stage",
        "value": "future-stage"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMDYxOTUyNA==",
        "name": "exhibition-stage",
        "value": "exhibition-stage"
    },
    {
        "id": "RmllbGRWYWx1ZV8xOTgzMTg2Nw==",
        "name": "inspiration-workshop-room",
        "value": "inspiration-workshop-room"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMjQ1NzUyOA==",
        "name": "workshop-room",
        "value": "workshop-room"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMjU3Nzc5NQ==",
        "name": "yanbu-workshop-room",
        "value": "yanbu-workshop-room"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMzQ0NjQwMA==",
        "name": "al-omsiat-b",
        "value": "al-omsiat-b"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMjU3ODg2Ng==",
        "name": "mansard-riyadh-a-radisson-collection-hotel",
        "value": "mansard-riyadh-a-radisson-collection-hotel"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMzMyODI4NA==",
        "name": "main-conference-room",
        "value": "main-conference-room"
    },
    {
        "id": "RmllbGRWYWx1ZV8yMzMyODM1NQ==",
        "name": "exhibition-hall",
        "value": "exhibition-hall"
    },
    {
        "id": "RmllbGRWYWx1ZV8yNTg4MzM4MA==",
        "name": "centre-stage",
        "value": "centre-stage"
    },
    {
        "id": "RmllbGRWYWx1ZV8yNTkzNDU1NQ==",
        "name": "future-hub",
        "value": "future-hub"
    },
    {
        "id": "RmllbGRWYWx1ZV8yNTkzNDU1Nw==",
        "name": "knowledge-hub",
        "value": "knowledge-hub"
    },
    {
        "id": "RmllbGRWYWx1ZV8yNTkzNDU1OA==",
        "name": "showcase-hub",
        "value": "showcase-hub"
    },
    {
        "id": "RmllbGRWYWx1ZV8yNTkzNDU1OQ==",
        "name": "pioneer-hub",
        "value": "pioneer-hub"
    },
    {
        "id": "RmllbGRWYWx1ZV8yNTkzNDU2MA==",
        "name": "the-forum",
        "value": "the-forum"
    },
    {
        "id": "RmllbGRWYWx1ZV8yNTk5MTYyMQ==",
        "name": "najd-workshop-room-2",
        "value": "najd-workshop-room-2"
    },
    {
        "id": "RmllbGRWYWx1ZV8yNjg3NTk4MA==",
        "name": "net-positive-solution-labs",
        "value": "net-positive-solution-labs"
    },
    {
        "id": "RmllbGRWYWx1ZV8yNjk4NTkzMg==",
        "name": "workshop-room-arena",
        "value": "workshop-room-arena"
    },
    {
        "id": "RmllbGRWYWx1ZV8yNzQyNjgyOA==",
        "name": "networking-lounge",
        "value": "networking-lounge"
    },
    {
        "id": "RmllbGRWYWx1ZV8yNzQyNjgyOQ==",
        "name": "investor-lounge",
        "value": "investor-lounge"
    }
]